import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface AlertMessage {
  type: 'info' | 'warning' | 'danger' | 'success';
  message: string;
  id?: number;
  ariaLive?: 'polite' | 'assertive';
}

@Injectable({ providedIn: 'root' })
export class AlertService {
  private alerts: AlertMessage[] = [];
  private _alertsSubject = new BehaviorSubject<AlertMessage[]>([]);
  alerts$ = this._alertsSubject.asObservable();
  private nextId = 0;

  showAlert(type: AlertMessage['type'], message: string, autoDismiss = true, timeout = 10000, ariaLive: 'polite' | 'assertive' = 'polite'): number {
    const id = this.nextId++;
    const alert: AlertMessage = { id, type, message, ariaLive };
    if(!this.alerts.find(ele => ele.message == message)){
      this.alerts.push(alert);
      this._alertsSubject.next([...this.alerts]);
    } else {
      return -1;
    }
    
    if(autoDismiss)
      console.log(`Alert [${id}] will auto-dismiss in ${timeout}ms`);
    if (autoDismiss) {
      setTimeout(() => {
        this.removeAlert(id);
        console.log(`Alert [${id}] dismissed`);
      }, timeout);
    }
    return id;
  }

  removeAlert(id: number) {
    this.alerts = this.alerts.filter(alert => alert.id !== id);
    this._alertsSubject.next([...this.alerts]);
  }

  clearAll() {
    this.alerts = [];
    this._alertsSubject.next([]);
  }

  /**
   * Show an alert that should be announced immediately by screen readers
   * Use for critical status messages that users need to know about right away
   */
  showCriticalAlert(type: AlertMessage['type'], message: string, autoDismiss = true, timeout = 10000): number {
    return this.showAlert(type, message, autoDismiss, timeout, 'assertive');
  }
}
